import css from 'styled-jsx/css';

export default css`
  .moduloContratar {
    display: flex;
    justify-content: center;
    gap: 3rem;
    margin-top: 35px;
    .sectionLeft {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
      width: 392px;
      background: #019df4;
      border-radius: 16px;
      padding: 30px;
    }
    .sectionRight {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
      width: 392px;
      background: #0b2739;
      border-radius: 16px;
      padding: 30px;
    }
  }
  @media screen and (max-width: 768px) {
    .moduloContratar {
      gap: 1rem;
      .sectionLeft {
        padding: 20px;
        min-width: 160px;
        :global(.title) {
          font-size: 18px;
        }
        :global(.description) {
          font-size: 16px;
        }
      }
      .sectionRight {
        padding: 19px;
        min-width: 160px;
        :global(.title) {
          font-size: 18px;
        }
        :global(.description) {
          font-size: 16px;
        }
      }
    }
  }
`;
